import { getTokenFromLocalStorage } from "./jwt";
import { sendSentryMessage } from "../utils/sentry";
import { sanitizeParticipantFormToPost } from "./formHelper";

export const findCpfOnServer = async (
  thisStore,
  participantCPF,
  caravanistUuid
) => {
  return new Promise((resolve) => {
    thisStore
      .dispatch("participant/exists", {
        cpf: participantCPF,
        uuid: caravanistUuid,
      })
      .then((cpfFound) => {
        resolve(cpfFound);
      })
      .catch(() => {
        resolve(null);
      });
  });
};

export const requestSmsFromServerForNewUser = async (thisStore, data) => {
  return new Promise((resolve) => {
    thisStore
      .dispatch("participant/requestSMSCodeCreate", data)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        console.log(err);
        resolve(null);
      });
  });
};

export const requestSmsFromServerForParticipantId = async (
  thisStore,
  participantId
) => {
  return new Promise((resolve) => {
    thisStore
      .dispatch("participant/requestSMSCode", participantId)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        console.log(err);
        resolve(null);
      });
  });
};

export const confirmSmsCodeOnServerForNewUser = async (
  thisStore,
  smsCode,
  mobile
) => {
  const sms = String(smsCode?.join(""));
  const payload = {
    mobile,
    code: sms,
  };
  return new Promise((resolve) => {
    thisStore
      .dispatch("participant/confirmSMSCreate", payload)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        let message = "Erro ao tentar Confirmar SMS";
        let type = "warning";
        if (err && err.response && err.response.status) {
          const status = err.response.status;
          if (status >= 400 <= 499) {
            type = "warning";
            message =
              "Usuário NOVO não informou o código correto 🤔 Erro:" + status;
          } else if (status > 499) {
            message =
              "Falha no SERVIDOR ao tentar Confirmar SMS - NOVO USER 🚨";
            type = "error";
          }
        }

        resolve(null);
        sendSentryMessage(message, type, "sms", {
          smsCode,
          err,
        });
      });
  });
};

export const confirmSmsCodeOnServerForParticipantId = async (
  thisStore,
  smsCode,
  participantId
) => {
  const sms = String(smsCode?.join(""));
  const payload = {
    id: participantId,
    code: sms,
  };
  return new Promise((resolve) => {
    thisStore
      .dispatch("participant/generateToken", payload)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        let message = "Erro ao tentar Confirmar SMS";
        let type = "warning";
        if (err && err.response && err.response.status) {
          const status = err.response.status;
          if (status >= 400 <= 499) {
            type = "warning";
            message =
              "Usuário EXISTENTE não informou o código correto 🤔 Erro:" +
              status;
          } else if (status > 499) {
            message =
              "Falha no SERVIDOR ao tentar Confirmar SMS - USER EXISTENTE 🚨";
            type = "error";
          }
        }

        resolve(null);
        sendSentryMessage(message, type, "sms", {
          participantId,
          smsCode,
          err,
        });
      });
  });
};
export const createParticipanteDataOnServer = async (
  thisStore,
  participant,
  token
) => {
  sanitizeParticipantFormToPost(participant);

  return new Promise((resolve, reject) => {
    thisStore
      .dispatch("participant/add", {
        participant,
        token: token || getTokenFromLocalStorage(),
      })
      .then((resp) => {
        resolve(resp.data);
        sendSentryMessage(
          "NOVO Participante criado com sucesso! 🟢🟢🟢",
          "info",
          "subscription"
        );
      })
      .catch((err) => {
        reject(err);
        sendSentryMessage(
          "Falha ao tentar cadastrar um NOVO participante ❌❌",
          "error",
          "subscription",
          {
            token: token || getTokenFromLocalStorage(),
            participantData: participant,
            err,
          }
        );
      });
  });
};

export const updateParticipanteDataOnServer = async (
  thisStore,
  participant,
  token
) => {
  sanitizeParticipantFormToPost(participant);
  return new Promise((resolve, reject) => {
    thisStore
      .dispatch("participant/updateProfile", {
        participant,
        token,
      })
      .then((resp) => {
        resolve(resp.data);
        sendSentryMessage(
          "Participante atualizado com sucesso! 🟢",
          "info",
          "subscription"
        );
      })
      .catch((err) => {
        reject(err);
        sendSentryMessage(
          "Falha ao tentar atualizar um participante ❌❌",
          "error",
          "subscription",
          {
            token: token,
            participantData: participant,
            err,
          }
        );
      });
  });
};

export const updateCaravanistList = (socket, caravanistUuid) => {
  if (socket && socket.readyState === 1) {
    socket.sendObj({
      uuid: caravanistUuid,
      action: "participantsListUpdated",
    });
  }
};
